export interface ILocationSettingConfig {
    [key: string]: {
        settingsPath: string,
        routerName: string,
        productTitle: string,
        knowMoreUrl: string,
        productUnitText?: string,
        productUnit?: string,
        enableModalContent: { html: string, isAgency497Check?: boolean }[],
    }
}

export const LOCATION_SETTING_CONFIG: ILocationSettingConfig = {
    reviewsAI: {
      settingsPath: '/settings/reviews-ai',
      routerName: 'location-setting-reviews-ai',
      productTitle: 'Reviews AI',
      knowMoreUrl: 'https://help.gohighlevel.com/a/solutions/articles/155000001074?portalId=48000045315',
      enableModalContent : [
          { html: '<b>Reviews AI</b> feature is chargeable for every message generation. This price is $0.08/review response.' },
          { html: 'Enable <b>Reviews Al in SaaS Configurator</b> and adjust the re-bill amount over the default price.' },
          { html: 'Enable the <b>Reviews Al Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.' },
          { html: 'On enabling Reviews Al Bot, based on usage around $0.08/message will be debited from the Agency Wallet for each message generated from any of the Agency Sub Accounts (Locations).' },
          { html: 'There are 2 modes that need to be enabled from each Sub Accounts (Locations) Settings:' },
          { html: '<b>Auto Response Mode</b> - The bot automatically sends out a response to new reviews obtained from review platforms.' },
          { html: '<b>Suggestive Mode</b> - The user can also regenerate responses up-to 3 times for no additional cost.' },
          { html: 'Each instance of a response/suggestion generation in both of the modes is charged at $0.08/message.' },
      ]
    },
    workflow_premium_actions: {
        settingsPath: '/settings/workflow-premium-actions',
        routerName: 'location-setting-workflow-premium-actions',
        productTitle: 'LC - Premium Triggers & Actions',
        knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/48001231559-lc-premium-triggers-actions-for-workflow',
        productUnitText: 'execution',
        enableModalContent : [
            { html: '<b>LC Premium Triggers and Actions</b> feature is chargeable for each execution and the default price is 0.01$/execution.' },
            { html: 'You can enable <b>LC Premium Triggers and Actions in SaaS Configurator</b> and adjust the re-bill amount over the default price.', isAgency497Check: true },
            { html: 'Enable the <b>LC Premium Triggers and Actions Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.', isAgency497Check: true },
            { html: 'On enabling LC Premium Triggers and Actions, 0.01$/execution will be debited from the Agency Wallet for each execution from any of the Agency Sub Accounts (Locations).' },
            { html: 'Each Sub Account (Location) will get 100 free executions to start off.' },
        ]
    },
    workflow_ai: {
      settingsPath: '/settings/workflow-ai',
      routerName: 'location-setting-workflow-ai',
      productTitle: 'Workflow AI',
      knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/155000000169-how-to-enable-and-rebill-workflow-ai-',
      productUnitText: 'execution',
      enableModalContent : [
          { html: '<b>Workflow AI</b> feature is chargeable for each execution and the default price is 0.03$/execution.' },
          { html: 'You can enable <b>Workflow AI in SaaS Configurator</b> and adjust the re-bill amount over the default price.', isAgency497Check: true },
          { html: 'Enable the <b>Workflow AI Re-billing</b> for the sub account to charge your Sub Accounts (Locations) based on their usage.', isAgency497Check: true },
          { html: 'On enabling Workflow AI, 0.03$/execution will be debited from the Agency Wallet for each execution from any of the Agency Sub Accounts (Locations).' },
          { html: 'Each Sub Account (Location) will get 100 free executions to start off.' },
      ]
  },
  contentAI: {
    settingsPath: '/settings/content-ai',
    routerName: 'location-setting-content-ai',
    productTitle: 'Content AI - Text And Image',
    knowMoreUrl: 'https://help.gohighlevel.com/support/solutions/articles/48001234826-how-to-enable-and-rebill-content-ai-',
    enableModalContent : [
        { html: '<b>Content AI</b> feature is chargeable for every use based on words calculation. The price is $0.09/1000 words.' },
        { html: 'Enable <b>Content AI in SaaS Configurator</b> and adjust the re-bill amount based on the default price.', isAgency497Check: true },
        { html: 'Enable the <b>Content AI Re-billing</b> for the sub account to charge your Sub-Accounts based on their usage.', isAgency497Check: true },
        { html: 'On enabling Content AI, based on usage around $0.09/1000 words will be debited from the Agency Wallet for each word from any of the Agency Sub Accounts (Locations).' },
        { html: 'Each Sub Account (Location) will get 500 free words to start off.' },
        { html: 'Pricing varies based on the number of words used in the prompt, the product area it\'s activated from and the words generated.' },
    ]
}
}



